import React, { useEffect, useState } from 'react'
import { FAQAccordionItem } from './FAQAccordionItem'
import type { CMSFAQAccordionItem } from '@/types/sanity'
import {
  PortableText,
  type PortableTextReactComponents,
} from '@portabletext/react'

import './FAQAccordion.scss'

interface FAQAccordionProps {
  items: CMSFAQAccordionItem[]
}

const portableTextComponents: Partial<PortableTextReactComponents> = {
  marks: {
    link: ({ children, value }) => {
      const { href } = value

      return (
        <a href={href} target="_blank" rel="noopener noreferrer">
          {children}
        </a>
      )
    },
  },
}

export const FAQAccordion: React.FC<FAQAccordionProps> = ({ items }) => {
  const [activeAccordionId, setActiveAccordionId] = useState<string>()

  useEffect(() => {
    const initialAccordion = items.find((el) => el.isOpen)
    if (initialAccordion) {
      setActiveAccordionId(initialAccordion._key ?? initialAccordion.id)
    }
  }, [])

  return (
    <div className="faq-accordion">
      {items?.map(({ _key, header, isOpen, body, id }) => (
        <FAQAccordionItem
          key={_key || id}
          id={_key || id!}
          isOpen={isOpen}
          activeAccordionId={activeAccordionId}
          setActiveAccordionId={(id) => setActiveAccordionId(id)}
        >
          <span className="faq-accordion__header type-label" slot="header">
            {header}
          </span>

          <div className="faq-accordion__body" slot="body">
            <PortableText value={body} components={portableTextComponents} />
          </div>
        </FAQAccordionItem>
      ))}
    </div>
  )
}
